<template>
  <div>
    <b-alert v-model="visible" :variant="type" dismissible>
      <div class="row">
        <div class="col-md-6 mt-1">
          <i class="fas fa-info-circle mr-2" />
          <span>{{ planTypeText }} {{ planFinishesInText }}</span>
        </div>
        <div class="col-md-6 mt-1 text-md-right">
          <b-button
            size="sm"
            class="ml-5 mb-0 mt-0"
            href="/assinar"
            variant="success"
            >{{ btnText }}</b-button
          >
        </div>
      </div>
    </b-alert>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data: function () {
    return {
      visible: false,
    };
  },

  computed: {
    lastSubscription() {
      return this.$store.state.company.last_subscription;
    },

    isOnFreePlan() {
      return this.lastSubscription.plan_id == 1;
    },

    isVisible() {
      return this.isOnFreePlan || this.planFinishesIn <= 5;
    },

    planFinishesIn() {
      return moment(this.lastSubscription.finish_at).diff(moment().startOf("day"),"days");
    },

    isFinished() {
      return this.planFinishesIn < 0;
    },

    type() {
      if (this.isFinished) {
        return "danger";
      }

      if (this.isOnFreePlan) {
        return "info";
      }

      return "warning";
    },

    planTypeText() {
      return this.isOnFreePlan ? "Seu período de teste " : "Sua assinatura";
    },

    planFinishesInText() {
      if (this.planFinishesIn < 0) {
        return "terminou.";
      }

      if (this.planFinishesIn == 0) {
        return "termina hoje";
      }

      if (this.planFinishesIn == 1) {
        return "termina amanhã";
      }

      return "termina em " + this.planFinishesIn + " dias";
    },

    btnText() {
      return this.isOnFreePlan ? "Assinar" : "Renovar";
    },
  },

  watch: {
    isVisible() {
      this.visible = this.isVisible;
    },
  },

  mounted() {
    this.visible = this.isVisible;
  },

  methods: {
    handleSignUp() {
      this.visible = false;
      this.$router.push("/assinatura");
    },
  },
};
</script>

<style>
</style>
